export default {
  data () {
    return {
      url: ''
    }
  },
  mounted () {
    let url = location.href.split(',')[0]
    let getUrl = url.substr(url.lastIndexOf('/') + 1)
    this.url = getUrl.substring(0, getUrl.indexOf('.'))
    console.log(this.url)
  }
}
